import SessionEventProto from "../session-event-proto"
import {AutomationNotification, EVENT_BUS_AUTOMATION_DISABLED_ON_ERRORS} from "./@const"
import {growlAutomationApplied, growlAutomationLimitReached} from "./growl"

/**
 * Every automation notification, in one event class.
 *
 * There is only ever ONE event shape (EntityType.AUTOMATION) — `method` says
 * which notification it is, and new notification types arrive as new method
 * strings on this same event. So this switches on the method and does nothing
 * for a method it does not know, rather than growing a class per notification.
 *
 * Backend: core/model/automation/automation/lib/session/notification.py
 */
export default class SessionEvent_AutomationNotification extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {

        if (this.isDifferentCompany()) return

        switch (this.method) {

            case AutomationNotification.SUCCESS:
                return growlAutomationApplied(_.get(this.data, 'automationId'))

            case AutomationNotification.LIMIT_REACHED:
                // no automationId in data - there is no single automation
                // behind a cascade limit
                return growlAutomationLimitReached()

            case AutomationNotification.DISABLED_ON_ERRORS:
                return this._onDisabledOnErrors()

            // A notification type this build does not know about yet. Nothing
            // to do is the correct answer - not a console error.
            default:
                return
        }
    }

    private _onDisabledOnErrors() {

        const automationId  = _.get(this.data, 'automationId')
        const errorCount    = _.get(this.data, 'errorCount')

        if (!automationId) return

        // whatever shows this automation flips it to disabled in place
        gd.bus.triggerEvent(EVENT_BUS_AUTOMATION_DISABLED_ON_ERRORS, {
            id          : automationId,
            errorCount  : errorCount,
        })

        // A toggle moving on its own needs a reason next to it. This is a
        // company-wide broadcast on purpose: the owner has to hear about it,
        // and it is not usually the person who tripped the last error.
        gd.growl.warning(
            'Automation disabled after {0} failed runs.'.f(errorCount || 0)
        )
    }
}
